import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((Theme) => ({
  cardHeader: {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: '16px',
    marginTop: 0,
    backgroundColor: 'transparent',

    [Theme.breakpoints.only('md')]: {
      marginBottom: '25px',
    },
    [Theme.breakpoints.up('lg')]: {
      marginBottom: '24px',
    },
  },
  cardHeaderPanel: {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: '20px',
  },

  cardTitle: {
    fontSize: Theme.typography.size[6],
    color: Theme.palette.primary.main,
    marginBottom: '10px',
    fontFamily: Theme.typography.base.semiBold,
    [Theme.breakpoints.up('sm')]: {
      fontSize: Theme.typography.size[7],
    },
    [Theme.breakpoints.up('md')]: {
      fontSize: Theme.typography.size[9],
    },
  },
  cardTitlePanel: {
    fontSize: Theme.typography.size[6],
    color: Theme.palette.primary.main,
    marginBottom: '10px',
    fontFamily: Theme.typography.base.semiBold,
  },
  cardTitleNoMarginBottom: {
    marginBottom: '0',
  },
  cardSubTitle: {
    fontSize: Theme.typography.size[3],
    color: Theme.palette.gray[750],
    fontFamily: Theme.typography.base.regular,
  },
  cardSubTitlePanel: {
    fontSize: Theme.typography.size[2],
    color: Theme.palette.gray[750],
    paddingBottom: '20px',
    borderBottom: `1px solid ${Theme.palette.gray[250]}`,
    marginBottom: '10px',
    [Theme.breakpoints.down('lg')]: {
      fontSize: Theme.typography.size[1],
    },
  },
  cardContainer: {
    display: 'flex',
    flexDirection: 'row',
    background: Theme.palette.white,
    borderRadius: '5px',

    [Theme.breakpoints.down('md')]: {
      flexDirection: 'column',
    },
  },
  cardContainerNoShadow: {
    borderTop: `1px solid ${Theme.palette.gray[250]}`,
    boxShadow: 'none',
    display: 'flex',
    paddingTop: 16,
    flexDirection: 'column',
    [Theme.breakpoints.up('lg')]: {
      flexDirection: 'row',
    },
  },
  cardContainerPanel: {
    display: 'flex',
    flexDirection: 'column',
  },
  cardFlightInfo: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: '2',
    width: '70%',
    [Theme.breakpoints.down('md')]: {
      paddingRight: '0',
      width: '100%',
    },
  },
  changeFlights: {
    flexDirection: 'column',
    borderTop: `1px solid ${Theme.palette.gray[250]}`,
    paddingLeft: 0,
    paddingTop: 24,

    [Theme.breakpoints.up('xl')]: {
      flexDirection: 'row',
    },

    [Theme.breakpoints.up('sm')]: {
      paddingTop: 16,
    },

    [Theme.breakpoints.up('lg')]: {
      paddingRight: 0,
    },
  },
  changeFlightsView: {
    flexDirection: 'column',
    [Theme.breakpoints.up('xl')]: {
      flexDirection: 'row',
    },
  },

  cardFlightSummary: {
    flexGrow: '1',
    borderLeft: `1px solid ${Theme.palette.gray[250]}`,
    paddingLeft: 24,
    paddingBottom: '10px',
    [Theme.breakpoints.up('lg')]: {
      marginLeft: 24,
    },
    [Theme.breakpoints.down('lg')]: {
      display: 'block',
      maxWidth: 'calc(360px - 61px)',
      paddingLeft: 24,
      flexGrow: '1',
    },
    [Theme.breakpoints.down('md')]: {
      maxWidth: '100%',
      width: '100%',
      display: 'flex',
      borderLeft: '0',
      borderTop: `1px solid ${Theme.palette.gray[250]}`,
      paddingLeft: '0',
      paddingTop: '20px',
      justifyContent: 'flex-end',
      paddingBottom: '0',
      marginTop: 24,
      minWidth: 'unset',
    },
  },
  cardFlightSummaryPanel: {
    flexGrow: '1',
    maxWidth: '100%',
    width: '100%',
    display: 'flex',
    borderLeft: '0',
    borderTop: `1px solid ${Theme.palette.gray[250]}`,
    paddingLeft: '0',
    paddingTop: '20px',
    justifyContent: 'flex-end',
    paddingBottom: '0',
  },
  cardFlightSummaryWrapper: {
    [Theme.breakpoints.down('md')]: {
      width: '410px',
    },
    [Theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  cardFlightSummaryWrapperPanel: {
    width: '100%',
  },
  summaryTitle: {
    fontSize: Theme.typography.size[3],
    color: Theme.palette.primary.main,
    fontFamily: Theme.typography.base.semiBold,
    lineHeight: '150%',
  },
  textAlignRight: {
    textAlign: 'right',
  },
  summaryTicket: {
    display: 'flex',
    flexDirection: 'row',
    fontFamily: Theme.typography.base.regular,
    fontSize: Theme.typography.size[1],
    color: Theme.palette.gray[750],
    justifyContent: 'space-between',
    flexWrap: 'wrap',

    '& >div': {
      width: '50%',
      paddingBottom: 10,
      paddingTop: 10,
      lineHeight: '24px',
    },

    '& >div:nth-child(even)': {
      textAlign: 'right',
    },
  },
  totalPrice: {
    paddingTop: 10,
    borderTop: `1px solid ${Theme.palette.gray[250]}`,
    display: 'flex',
    flexDirection: 'row',
    fontSize: Theme.typography.size[3],
    color: Theme.palette.primary.main,
    justifyContent: 'space-between',
    fontFamily: Theme.typography.base.semiBold,
    lineHeight: '24px',
    [Theme.breakpoints.down('md')]: {
      marginTop: 16,
    },
  },
  accordionContainer: {
    margin: '16px',
  },
  centeredAccordionDetails: {
    display: 'block',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '0px 16px 16px',
    '& .MuiAccordionDetails-root': {
      display: 'block',
      justifyContent: 'center',
    },

    [Theme.breakpoints.up('md')]: {
      padding: 24,
      paddingTop: 0,
    },
  },
  accordionSummary: {
    alignItems: 'flex-start',
    '& .MuiAccordionSummary-content': {
      display: 'flex',
      justifyContent: 'space-between',
      margin: 0,
      padding: '16px 0px',
      flexDirection: 'column',

      [Theme.breakpoints.up('sm')]: {
        flexDirection: 'row',
        alignItems: 'center',
      },

      [Theme.breakpoints.up('md')]: {
        padding: '24px 8px 16px',
      },
    },
    [Theme.breakpoints.up('md')]: {
      alignItems: 'center',
    },
    '& p': {
      color: `${Theme.palette.primary.main}`,
      fontSize: Theme.typography.size[4],
      fontFamily: Theme.typography.base.semiBold,
      marginBottom: 8,

      [Theme.breakpoints.up('sm')]: {
        marginBottom: 0,
      },
    },
    '& p:last-child': {
      fontSize: Theme.typography.size[2],
      marginBottom: 0,
    },
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  expandIcon: {
    color: `${Theme.palette.primary.light}`,
  },
  dueDate: {
    display: 'flex',
    justifyContent: 'space-between',
    lineHeight: '24px',
    marginTop: '5px',
    fontSize: Theme.typography.size[1],
    color: `${Theme.palette.primary.main}`,
    fontFamily: Theme.typography.base.regular,
    '& span:last-child': {
      textTransform: 'capitalize',
    },
  },
  summarySpacing: {
    paddingTop: '0px !important',
  },
  headerClass: {
    border: '1px solid red',
  },
}));

export default useStyles;
